module.exports = require('gl-quat/slerp')


//////////////////
// WEBPACK FOOTER
// ./node_modules/3d-view-controls/node_modules/3d-view/node_modules/matrix-camera-controller/node_modules/mat4-interpolate/node_modules/quat-slerp/index.js
// module id = 65
// module chunks = 0